export default "__VITE_ASSET__CDegajKR__"